import { Type } from '@angular/core';

import { BetslipError } from './betslip-error';

export interface INotifyUserError {
    userHasBeenNotified: boolean;

    markAsSeen(): void;
}

export declare class NotifyUserError extends BetslipError implements INotifyUserError {
    userHasBeenNotified: boolean;
    markAsSeen(): void;
}

export type ErrorConstructor<T extends BetslipError> = new (...args: any[]) => T;

export function NotifyUserErrorMixin<
    TBaseError extends BetslipError,
    TBaseErrorType extends ErrorConstructor<TBaseError> = ErrorConstructor<TBaseError>,
>(
    // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
    BaseErrorType: TBaseErrorType,
): Type<TBaseError & INotifyUserError> {
    // @ts-ignore Constructor type https://github.com/Microsoft/TypeScript/issues/16390
    return class extends BaseErrorType implements INotifyUserError {
        constructor(...args: any[]) {
            super(...args);
            this.userHasBeenNotified = false;
        }

        userHasBeenNotified: boolean;

        markAsSeen(): void {
            this.userHasBeenNotified = true;
        }
    };
}
